export { default } from './UnscoredCategoryPageWhyTotallyMoneySection'
